import React, { useRef } from 'react';

import { Button } from 'components/Misc/Form';
import Show from 'components/Show';

const Toolbar = ({ active, percentage, uploading, removing, onUpload, onDelete }) => {
	// Create reference for file upload's input
	const input = useRef(null);

	// Handle onClick event
	// @event: object | default onClick event
	const onClick = event => {
		event.preventDefault();

		// Focus on input's field
		input.current.click();
	};

	// Handle onChange event
	// @event: object | default onChange event
	const onChange = event => {
		const { files } = event.target;
		
		// Upload selected files in main component
		onUpload(files);

		// Blur input's field
		input.current.blur();

		// Reset input's value
		input.current.value = '';
	};

	return (
		<div className="flex justify-end space-x-2">
			<Show if={active !== ''}>
				<Button
					value="Dzēst"
					icon="delete"
					theme="danger"
					progress={removing}
					onClick={onDelete}
				/>
			</Show>

			<Button
				value="Augšupielādēt"
				icon="upload"
				theme="success"
				progress={uploading}
				percentage={percentage}
				onClick={onClick}
			/>

			<input
				multiple
				ref={input}
				type="file"
				name="files"
				onChange={onChange}
				className="hidden"
			/>
		</div>
	);
};

export default Toolbar;